<template>
    <div style="height: 100%">
        <div class="chart" ref="chartdiv"></div>
    </div>
</template>

<script>

    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import themeDark from "@amcharts/amcharts4/themes/dark";

    am4core.useTheme(themeDark);

    export default {

        components: {},

        props: {
            data: {
                type: Array,
                required: true
            },
            title: {
                type: String,
                required: false,
                default: null
            },
            categoriesTitle: {
                type: String,
                required: false,
                default: null
            },
            valuesTitle: {
                type: String,
                required: false,
                default: null
            }
        },

        data() {
            return {
                chart: null,
            }
        },

        watch: {
            data() {
                this.prepareChart();
            }
        },

        mounted() {
            this.prepareChart();
        },

        methods: {

            prepareData() {
                this.chart.data = this.data;
            },

            prepareChart() {

                if (this.data.length === 0) return false;

                this.chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
                this.chart.colors.list = [
                    am4core.color("#1976D2"),
                    am4core.color("#FFAB00"),
                    am4core.color("#BF360C"),
                    am4core.color("#388E3C"),
                    am4core.color("#FFC75F"),
                    am4core.color("#F9F871")
                ];

                if (this.title) {
                    let title = this.chart.titles.create();
                    title.text = this.title;
                    title.fontSize = 25;
                    title.marginBottom = 15;
                }

                let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "label";
                categoryAxis.renderer.minGridDistance = 30;
                categoryAxis.renderer.labels.template.disabled = true;
                categoryAxis.renderer.grid.template.location = 0;

                if (this.categoriesTitle) {
                    categoryAxis.title.text = this.categoriesTitle;
                    categoryAxis.title.marginRight = 10;
                    //categoryAxis.title.fontSize = 30;
                }

                let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;

                if (this.valuesTitle) {
                    valueAxis.title.text = this.valuesTitle;
                }

                // Create series
                let series = this.chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueX = "percent";
                series.dataFields.categoryY = "label";
                series.columns.template.tooltipText = "[bold]{percent}%[/] {label}  ({value})";
                series.columns.template.fillOpacity = .8;

                series.stroke = am4core.color("#81abff");
                series.columns.template.strokeWidth = 2;
                series.columns.template.strokeOpacity = 0.5;

                let bullet = series.bullets.push(new am4charts.LabelBullet);
                bullet.label.text = "{label}";
                //bullet.label.fontSize = 20;
                //bullet.label.rotation = 90;
                bullet.label.truncate = true;
                bullet.label.hideOversized = false;
                bullet.label.horizontalCenter = "right";
                bullet.label.align="left";
                bullet.label.opacity = 1;
                bullet.locationX = 0;
                bullet.dx = -10;

                //this.chart.paddingBottom = 100;
                this.chart.maskBullets = false;

                // Recalculate bar size based on how many items are there
                this.chart.events.on("datavalidated", function(ev) {
                    // Set cell size in pixels
                    let cellSize = 30;

                    // Get objects of interest
                    let chart = ev.target;
                    let categoryAxis = chart.yAxes.getIndex(0);

                    // Calculate how we need to adjust chart height
                    let adjustHeight = chart.data.length * cellSize - categoryAxis.pixelHeight;

                    // get current chart height
                    let targetHeight = chart.pixelHeight + adjustHeight;

                    // Set it on chart's container
                    chart.svgContainer.htmlElement.style.height = targetHeight + "px";
                });

                this.prepareData();
            }
        }
    }
</script>
